import styled, { css } from 'styled-components';
import { text } from "../../lib/sharedStyles";

export const Tile = styled.a<{
  $hasHoverImg: boolean;
  $layout?: string;
  $showVariantHoverImage: boolean;
  $brand?: string;
  $theme?: string;
}>`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  position: relative;
  transition: all 0.3s ease;

  ${({ $layout }) =>
    $layout == 'list' &&
    css`
      flex-direction: row;
      padding: 16px;
    `}

    ${({ $brand, $theme }) =>
      $brand == 'jackson' && `
      margin-top: 14px;
      border: 1px solid transparent;
      padding: 0px;
      
      &:hover {
        border: 1px solid ${$theme === 'dark' ? '#666' : '#000'};
      }
    `}

  // For products without swatches, or the base product in a swatch list, the second image is shown.
  ${({ $hasHoverImg, $showVariantHoverImage }) => $hasHoverImg && !$showVariantHoverImage && `
    &:hover {
      > div > img:nth-of-type(1) {
        opacity: 0;
      }
      > div > img:nth-of-type(2) {
        opacity: 1;
      }
    }
  `}

  // When hovering on a variant, don't show the usual (2nd) hover image, but the variant image.
  ${({ $hasHoverImg, $showVariantHoverImage }) => $hasHoverImg && $showVariantHoverImage && `
    &:hover {
      > div > img:nth-of-type(1) {
        opacity: 0;
      }
      > div > img:nth-of-type(3) {
        opacity: 1;
      }ß
    }
  `}

  .limoniapps-discountninja-badge-wrapper {
    display: none;
  }
`;

export const ImageContainer = styled.div<{
  $layout?: string;
  $noRotate: boolean;
  $leftHanded: boolean;
  $brand?: string;
}>`
  position: relative;
  overflow: hidden;
  aspect-ratio: 1 / 1.4;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }

  img:nth-of-type(1) {
    object-fit: contain;
    transform: rotate(-90deg);

    ${({ $leftHanded }) => $leftHanded && `
      transform: rotate(90deg);
    `}

    ${({ $noRotate }) => $noRotate && `
      transform: none;
    `}
  }

  ${({ $layout }) =>
    $layout == "grid" &&
    `
    aspect-ratio: 1 / 1.3;
  `}

  ${({ $layout }) =>
    $layout == "list" &&
    `
    aspect-ratio: 1 / 0.65;
    padding: 0 32px;
    display: flex;
    align-items: center;
  `}

  ${({ $brand }) =>
  $brand == 'fender' &&
  css`
    padding: 32px 40px;
    background: linear-gradient(180deg, #E5E5E5 0%, #EFF0F0 59.6%, #F7F7F7 100%);
  `}

  ${({ $brand }) =>
  $brand == 'presonus' &&
  css`
    border-radius: 16px;
    padding: 40px;
    background-color: #F5F5F5;
  `}

  ${({ $brand }) =>
  $brand == 'jackson' &&
  css`
    background-color: #F1F1F1;
  `}
`;

export const HoverImage = styled.img<{
  $objectFit?: string;
  $isCustomHoverImage?: boolean;
  $noRotate?: boolean;
  $isVariantHoverImage?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${({ $objectFit }) => $objectFit || 'contain'};
  opacity: 0;
  transform: rotate(90deg);
  box-sizing: border-box;
  padding: ${({ $isCustomHoverImage }) => ($isCustomHoverImage ? '0' : 'inherit')};

  ${({ $isVariantHoverImage }) => $isVariantHoverImage && `
    transform: rotate(-90deg);
  `}

  ${({ $noRotate }) => $noRotate && `
    transform: none;
  `}
`;

export const ContentContainer = styled.div<{ $brand?: string }>`
  display: flex;
  flex-direction: column;
  margin: 0;
  margin-top: 10px;
  padding: 0;

  ${({ $brand }) =>
    $brand == 'jackson' &&`
      min-height: 170px;
      padding-left: 20px;
    `
  }
`;

export const Title = styled.p<{ $brand?: string }>`
  margin: 0px;
  ${text(500, '16px', '20px', '#1A1B1B')};

  ${({ $brand }) =>
    $brand == 'jackson' &&`
      color: #020202;
      font-family: 'Palanquin Dark', sans-serif;
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.5rem;
    `
  }

  ${({ $brand }) =>
    $brand == 'fender' &&`
      font-weight: 600;
      letter-spacing: -0.02em;
    `
  }
`;

export const PriceContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const Price = styled.p<{ $layout?: string; $brand?: string; $theme: string }>`
  margin: 0;
  margin-top: 4px;
  ${text(400, '12px', '22px', '#1A1B1B')}

  @media (min-width: 768px) {
    ${text(400, '16px', '24px', '#1A1B1B')}
  }

  ${({ $brand, $theme }) =>
    $brand == 'jackson' && `
      font-family: Palanquin Dark, sans-serif;
      color: ${$theme == 'dark' ? 'rgba(255, 255, 255, 0.8)' : '#000'} !important;
      font-size: 1.3125rem !important;
      font-weight: 500;
      line-height: 1.96875rem;
      letter-spacing: 0.0175rem;
  
      @media (min-width: 768px) {
        line-height: 1.96875rem;
      }

      > div.limoniapps-discountninja-productprice-replaced {
        .limoniapps-discountninja-strikethrough,
        .limoniapps-discountninja-shortcode-original_price .money{
          color: ${$theme == 'dark' ? 'rgba(255, 255, 255, 0.8)' : '#000'} !important;
        }
      }
  
      .limoniapps-discountninja-productprice-replaced.limoniapps-discountninja-otherpage {
        .limoniapps-discountninja-shortcode-discounted_price,
        .limoniapps-discountninja-shortcode-original_price {
          font-weight: 500 !important;

          .money {
            font-weight: 500 !important;
          }
        }
      }
    `}

  ${({ $layout }) =>
    $layout == "list" &&
    css`
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0.18px;
    `}

  .limoniapps-discountninja-discountedprice {
    .limoniapps-discountninja-shortcode-original_price .money {
      color: #888888 !important;
    }
  }

  .limoniapps-discountninja-discountedprice strike {
    color: #888888 !important;
  }

  #save-block {
    display: none !important;
  }
`;

export const BadgeWrapper = styled.div<{ $brand?: string }>`
  margin-bottom: 0;
  position: absolute;
  left: 16px;
  top: 16px;
  letter-spacing: 0.5px;
  line-height: 1;
  z-index: 10;
`;

const FenderTextBadgeStyling = css`
  ${text(600, "12px", "18px", "#A02729")}
  font-family: "Instrument Sans";
  letter-spacing: 0.12px;
`;

const FenderTextBadgeTwoStyling = css`
  ${text(600, "12px", "18px", "#A47000")}
  font-family: "Instrument Sans";
  letter-spacing: 0.12px;
  padding-left: 8px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    height: 12px;
    width: 1px;
    background-color: #191A1F30;
  }
`;

const PresonusTextBadgeStyling = css`
  ${text(500, "16px", "20px", "#0083FF")}
  margin-bottom: 4px;
`;

const JacksonTextBadgeStyling = css<{ $theme: string }>`
  ${text(600, "12px", "18px", "#2d0684")}
  font-family: Palanquin Dark,sans-serif;
  letter-spacing: .0625rem;
  text-transform: uppercase;
  padding-right: 20px;
  padding-bottom: 10px;
  color: ${({ $theme }) => ($theme === 'dark' ? '#8F5EF7' : '#2d0684')};
`;

const PresonusProductBadgeStyling = css`
  ${text(400, '16px', '24px', '#FF19A5')};
  margin-top: 4px;
`;

const JacksonProductBadgeStyling = css`
  ${text(500, '.75rem', '0.9375rem', '#FFF')};
  font-family: Palanquin Dark, sans-serif;
  letter-spacing: .03313rem;
  text-transform: uppercase;
  white-space: nowrap;
  background-color: #287104;
  border-color: #287104;
  align-items: center;
  justify-content: center;
  height: auto;
  padding: 2px 12px;
  width: auto;
  position: absolute;
  top: -12px;
  left: 50%;
  right: unset;
  z-index: 1;
  transform: translateX(-50%);
`;

const PresonusCalloutStyling = css`
  ${text(400, "16px", "24px", "#14816E")}
`;

const JacksonCalloutStyling = css`
  ${text(500, ".875rem", "1.09375rem", "#287104")}
  font-family: Palanquin, sans-serif;
  letter-spacing: 0;
  margin-top: 4px;
`;

export const Badge = styled.div<{
  $brand: string;
  $theme: string;
  $badgeType: 'text' | 'textTwo' | 'product' | 'callout';
}>`
  ${({ $badgeType, $brand }) => {
    switch ($badgeType) {
      case 'text':
        return $brand == 'jackson'
          ? JacksonTextBadgeStyling
          : $brand == 'presonus'
          ? PresonusTextBadgeStyling
          : FenderTextBadgeStyling;
      case 'textTwo':
        return FenderTextBadgeTwoStyling;
      case 'product':
        return $brand == 'jackson'
          ? JacksonProductBadgeStyling
          : PresonusProductBadgeStyling;
      case 'callout':
        return $brand == 'jackson'
          ? JacksonCalloutStyling
          : PresonusCalloutStyling;
      default:
        return '';
    }
  }}
`;

export const TextBadgeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
`;